import React, { Component } from 'react';
import { Field } from 'redux-form';
import { BooleanInput, ReferenceInput, SelectInput, TextInput } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import isPresent from '../../../Common/Utils/Present';

const ValidateRequired = required();
const ValidateOnCreate = (props) => (isPresent(props.record) ? null : required());

const styles = createStyles({
  email: {
    width: 320
  },
  name: {
    width: 250
  },
  password: {
    width: 250
  }
});

type Props = {
  classes: any,
  record?: any
};

const SettingsTab = (props) => (
  <div style={{ paddingTop: 20 }}>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field name="active" source="active" component={BooleanInput} label="Active" style={{ width: '0' }} />
      </div>
      <div style={{ flex: 2 }}>
        <Field name="debugger" source="debugger" component={BooleanInput} label="Show SQL Queries" style={{ width: '170px' }} />
      </div>
    </div>

    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field name="first_name" source="first_name" component={TextInput} label="First name *" validate={ValidateRequired} className={props.classes.name} /><br />
      </div>
      <div style={{ flex: 2 }}>
        <Field name="last_name" source="last_name" component={TextInput} label="Last name *" validate={ValidateRequired} className={props.classes.name} /><br />
      </div>
    </div>

    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field name="password" source="password" component={TextInput} type="password" label="Password" validate={ValidateOnCreate(props)} className={props.classes.password} /> &nbsp; &nbsp;
      </div>
      <div style={{ flex: 2 }}>
        <Field name="password_confirmation" source="password_confirmation" component={TextInput} type="password" label="Password confirmation" validate={ValidateOnCreate(props)} className={props.classes.password} />
      </div>
    </div>

    <Field name="email" source="email" component={TextInput} type="email" label="Email *" validate={ValidateRequired} className={props.classes.email} /><br />
    <Field name="team_id" source="team_id" component={ReferenceInput} label="Select Team *" resource="users" reference="helpers/teams" sort={{ field: 'name', order: 'ASC' }} allowEmpty record={props.record}>
      <Field name="team_id" source="team_id" component={SelectInput} validate={ValidateRequired} />
    </Field><br /><br />

    <Field name="api_token" source="api_token" component={TextInput} label="API Token" fullWidth /><br />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Users/Partials/SettingsTab.tsx